import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import CreditCard from "@/models/api/administration/bankAccounts/CreditCard";

export default class CreditCardList extends GenericTableResponse<CreditCard> {
  @Type(() => CreditCard)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CreditCard>;
}
